<template>
  <v-card>
    <s-crud
      ref="gridcuadrillas"
      title="Gestión de Cuadrillas"
      :config="config"
      :filter="filter"
      add
      edit
      remove
      searchInput
      @save="save($event)"
      @add="onAdd()"
      @edit="onEdit($event)"
      @rowSelected="rowSelected($event)"
    >
      <template v-slot="props">
        <v-container>
          <v-row dense>
            <v-col cols="12" md="7" class="s-col-form">
              <s-text
                label="Nombre de Cuadrilla*"
                v-model="props.item.GngName"
                placeholder="Ej. Cuadrilla Cosecha A"
              />
            </v-col>
            <v-col cols="12" md="5" class="s-col-form">
              <s-text
                label="Código / SreID"
                v-model="props.item.SreID"
                placeholder="Código identificador"
              />
            </v-col>
            <v-col cols="12" md="6" class="s-col-form" v-if="props.item.GngID">
              <s-select
                label="Estado"
                :items="statusOptions"
                item-text="text"
                item-value="value"
                v-model="props.item.SecStatus"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:SecStatus="{ row }">
        <v-chip
          x-small
          dark
          :color="row.SecStatus == 1 ? 'success' : 'error'"
        >
          {{ row.SecStatus == 1 ? 'ACTIVO' : 'INACTIVO' }}
        </v-chip>
      </template>
    </s-crud>
  </v-card>
</template>

<script>
import _sGangService from "@/services/HumanResource/hmnGang.js";
import SText from "@/components/Utils/SText.vue";

export default {
  name: "hmnGang",
  components: {
    SText,
  },
  data() {
    return {
      selected: null,
      filter: {},
      statusOptions: [
        { value: 1, text: "Activo" },
        { value: 0, text: "Inactivo" },
      ],
      config: {
        service: _sGangService,
        model: {
          GngID: "ID",
          GngName: "string",
          SreID: "string",
          SecStatus: 1,
        },
        headers: [
          { text: "ID", value: "GngID", width: "90px" },
          { text: "Nombre de Cuadrilla", value: "GngName" },
          { text: "SreID", value: "SreID", width: "180px" },
          { text: "Estado", value: "SecStatus", align: "center", width: "130px" },
        ],
      },
    };
  },
  methods: {
    onAdd() {
      this.selected = null;
    },
    onEdit(item) {
      this.selected = item;
    },
    rowSelected(items) {
      if (items && items.length > 0) {
        this.selected = items[0];
      } else {
        this.selected = null;
      }
    },
    validationForm(item) {
      const result = {
        errors: 0,
        message: "",
      };

      if (!item.GngName || String(item.GngName).trim().length === 0) {
        result.errors = 1;
        result.message = "El nombre de la cuadrilla es obligatorio.";
      }

      return result;
    },
    save(item) {
      const validation = this.validationForm(item);
      if (validation.errors > 0) {
        this.$fun.alert(validation.message, "warning");
        return;
      }

      if (item.SecStatus === undefined || item.SecStatus === null) {
        item.SecStatus = 1;
      }

      item.save();
    },
  },
};
</script>

<style scoped></style>